<head-meta [title]="this.title"></head-meta>
<app-help-button src="/assets/help/users/listing.md" />
<article>
    <div class="card w-full bg-base-100 shadow-xl">
        <div class="card-body">
            <div class="navbar bg-base-100">
                <div class="flex-none">
                </div>
                <div class="flex-1">
                  <h1 class="h1 mr-4">{{this.title}}</h1>
                  <form [formGroup]="this.searchForm">
                    <div class="form-control">
                        <div class="ml-4 input-group flex items-center gap-2 w-full max-w-md">
                            <select class="input input-bordered input-md w-40" formControlName="status" name="status">
                                <option value="all">All</option>
                                <option value="active">Active</option>
                                <option value="disabled">Disabled</option>
                            </select>
                            <button class="btn btn-square btn-md" [disabled]="!this.searchForm.valid" (click)="this.submit()">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                  </form>
                </div>
                <div class="flex-none">
                    @if(this.auth.has('user_create')) {
                        <button routerLink="/users/create" routerLinkActive="active" class="btn btn-ghost text-primary"><fa-icon [icon]="faCirclePlus" class="w-5"></fa-icon> Add</button>
                    }
                </div>
            </div>
            <hr class="hr" />
            <table class="table table-zebra table-pin-rows">
                <ng-container *ngrxLet="users$ as users; error as e; complete as c">
                    <app-loading-error-block [error]="e?.error" [complete]="c" />
                    @if(c) {
                        <thead>
                            <th>Name</th>
                            <th>Providers</th>
                            <th>Roles</th>
                            <th>Status</th>
                        </thead>
                        <tbody>
                            @if(users.length > 0) {
                                @for (user of users; track $index) {
                                    <tr [routerLink]="'/users/' + user.id" class="cursor-pointer">
                                        <td>{{ user.display_name }}</td>
                                        <td>{{ formatWithOverflow(user.provider_names, 2) }}</td>
                                        <td>{{ formatWithOverflow(user.role_names, 2) }}</td>
                                        <td>
                                            @if(user.is_banned) {
                                                <span class="badge badge-error badge-sm">Disabled</span>
                                            } @else {
                                                <span class="badge badge-success badge-sm">Active</span>
                                            }
                                        </td>
                                    </tr>
                                }
                            } @else {
                                <tr>
                                    <td class="text-center" colspan="4">
                                        <span class="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center">
                                            <span class="mt-2 block text-sm text-gray-400">No Users</span>
                                        </span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    }
                </ng-container>
            </table>
        </div>
    </div>
</article>